import React from "react";
import { useParams } from "react-router-dom";
import SEO from "../components/SEO";
import FooterFour from "../components/FooterFour";
import NavBar from "../components/NavbarTwo";
import TeamDetailsGroup from "../components/TeamDetailsGroup";

const TeamDetailsSingle = () => {
  const { id } = useParams();
  return (
    <>
      <SEO
        title="Team Member"
        description="EvolveLab team member profile."
        canonical={`/team/${id}`}
        noindex
      />
      <NavBar />
      <TeamDetailsGroup />
      <FooterFour />
    </>
  );
};

export default TeamDetailsSingle;
